import React from "react";
import { Typography } from "@material-ui/core";
import { CssTextField } from "./style";

export const LeaderboardForm = ({
	classes,
	userId,
	setUserId,
	botCount,
	setBotCount,
	minRange,
	setMinRange,
	maxRange,
	setMaxRange,
}) => {
	return (
		<>
			<Typography variant="h6" className={classes.sectionTitle}>
				Leaderboard Bots
			</Typography>
			<div className={classes.inputRow}>
				<CssTextField
					className={classes.textField}
					label="User ID"
					variant="outlined"
					value={userId}
					onChange={(e) => setUserId(e.target.value)}
					required
				/>
				<CssTextField
					className={classes.textField}
					label="Bot Count"
					variant="outlined"
					type="number"
					value={botCount}
					onChange={(e) => setBotCount(e.target.value)}
					error={
						botCount && (parseInt(botCount) <= 0 || parseInt(botCount) > 200)
					}
					helperText={
						botCount && parseInt(botCount) <= 0
							? "Bot count must be positive"
							: botCount && parseInt(botCount) > 200
							? "Bot count must be at most 200"
							: ""
					}
					InputProps={{
						inputProps: { min: 1, max: 200 },
					}}
					required
				/>
				<CssTextField
					className={classes.textField}
					label="Min Range"
					variant="outlined"
					type="number"
					value={minRange}
					onChange={(e) => setMinRange(e.target.value)}
					error={minRange && parseInt(minRange) < 1}
					helperText={
						minRange && parseInt(minRange) < 1
							? "Minimum range must be at least 1"
							: ""
					}
					InputProps={{
						inputProps: { min: 1 },
					}}
					required
				/>
				<CssTextField
					className={classes.textField}
					label="Max Range"
					variant="outlined"
					type="number"
					value={maxRange}
					onChange={(e) => setMaxRange(e.target.value)}
					error={
						(maxRange && parseInt(maxRange) > 10000) ||
						(minRange && maxRange && parseInt(minRange) >= parseInt(maxRange))
					}
					helperText={
						maxRange && parseInt(maxRange) > 10000
							? "Maximum range must be at most 10000"
							: minRange && maxRange && parseInt(minRange) >= parseInt(maxRange)
							? "Maximum range must be greater than minimum range"
							: ""
					}
					InputProps={{
						inputProps: { max: 10000 },
					}}
					required
				/>
			</div>
		</>
	);
};

export const validateLeaderboardForm = (formData) => {
	const { userId, botCount, minRange, maxRange } = formData;
	return (
		userId &&
		botCount &&
		minRange &&
		maxRange &&
		parseInt(botCount) > 0 &&
		parseInt(botCount) <= 200 &&
		parseInt(minRange) >= 1 &&
		parseInt(maxRange) <= 10000 &&
		parseInt(minRange) < parseInt(maxRange)
	);
};

// export {
//   LeaderboardForm,
//   validateLeaderboardForm
// };
